/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 24/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
* --------------------------------------------------------------------------------------- */

import TextField from "../ui/TextField";
import React, { Fragment, useState, useEffect } from "react";
import { Modal, Box, MenuItem } from "@mui/material";

// Estilos para el modal con efecto suavizado de desplazamiento
const modalStyle = {
    position: 'fixed',
    top: '15%',
    right: '28%',
    width: '50vw',
    height: '55vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    transform: 'translateX(300%)', // Inicialmente fuera de la pantalla
    transition: 'transform 0.5s ease-in-out', // Duración de la animación
};

export default function ModalEditarPartidasVentas(props) {
    const { openModal, rowSelect = {}, handleClose, handleEliminar, handleSubmitEditarPartidaVentaSumar, handleSubmitEditarPartidaVentaRestar } = props;

    const [modalVisible, setModalVisible] = useState(false); // Controla el desplazamiento del modal
    const [internalOpen, setInternalOpen] = useState(false); // Controla el estado real de apertura del modal

    const [cantidadSumar, setCantidadSumar] = useState(1);
    const [cantidadRestar, setCantidadRestar] = useState(1);

    // Efecto para manejar la apertura/cierre con retardo para permitir la animación
    useEffect(() => {
        if (openModal) {
            setInternalOpen(true); // Abre el modal de inmediato
            setTimeout(() => {
                setModalVisible(true); // Muestra el modal después de un pequeño retardo
            }, 50); // Un pequeño retraso para que la animación comience
        } else {
            setModalVisible(false); // Inicia la animación de salida
            setTimeout(() => {
                setInternalOpen(false); // Cierra el modal solo después de que la animación haya terminado
            }, 500); // 500ms coincide con la duración de la animación
        }
    }, [openModal]);

    const modalVisibleStyle = {
        transform: modalVisible ? 'translateX(0)' : 'translateX(300%)', // Controla la entrada/salida
    };

    return (
        <Modal
            open={internalOpen} // Controla la visibilidad real del modal
            onClose={handleClose} // Cierra al hacer clic fuera del modal
            aria-labelledby="menu-modal-title"
            aria-describedby="menu-modal-description"
            closeAfterTransition // Esto permite que el contenido espere la transición
        >
            <Box sx={{
                ...modalStyle,
                ...modalVisibleStyle, // Aplicamos la animación condicional
            }}>
                <Fragment>
                    <div className="container">
                        {/* Información de la partida */}
                        <div className="partidaInfo">
                            <div><strong>ID Partida:</strong> {rowSelect.idpartida}</div>
                            <div><strong>Descripción:</strong> {rowSelect.descripcion}</div>
                            <div><strong>Cantidad Actual:</strong> {rowSelect.cantidad}</div>
                        </div>

                        {/* Separador azul cian */}
                        <hr className="separator" />

                        {/* Sección de suma */}
                        <div className="actionSection">
                            <TextField autoComplete="off"       
                                name="idcantidadsumar"
                                label="Cantidad a sumar:"
                                value={cantidadSumar}
                                onChange={(e) => setCantidadSumar(Number(e.target.value) || 1)}
                                error={false}
                                helperText=""
                                sx={{ width: '150px' }}
                                select
                            >
                                <MenuItem value="">--Seleccionar--</MenuItem>
                                {[1, 2, 3, 4, 5, 6]?.map((x) => (
                                    <MenuItem key={x} value={x}>
                                        {x}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <button className="button" onClick={() => handleSubmitEditarPartidaVentaSumar(cantidadSumar, rowSelect.idpartida,rowSelect.clavearticulo,rowSelect.medida)}>Sumar</button>
                        </div>
                        {/* Separador azul cian */}
                        <hr className="separator" />
    
                        {/* Sección de resta */}
                        <div className="actionSection">
                        <TextField autoComplete="off"       
                                name="idcantidadrestar"
                                label="Cantidad a restar:"
                                value={cantidadRestar}
                                onChange={(e) => setCantidadRestar(Number(e.target.value) || 1)}
                                error={false}
                                helperText=""
                                sx={{ width: '150px' }}
                                select
                            >
                                <MenuItem value="">--Seleccionar--</MenuItem>
                                {[1, 2, 3, 4, 5, 6]?.map((x) => (
                                    <MenuItem key={x} value={x}>
                                        {x}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <button className="button" onClick={() => handleSubmitEditarPartidaVentaRestar(cantidadRestar, rowSelect.idpartida,rowSelect.clavearticulo,rowSelect.medida)}>Restar</button>
                        </div>

                        {/* Separador azul cian */}
                        <hr className="separator" />

                         {/* Botón de eliminar partida */}
                         <button className="button" onClick={handleEliminar}>Eliminar Partida</button>
                    </div>
                </Fragment>
            </Box>
        </Modal>
    );
}
